import { gql } from '@apollo/client'

export const SABRE_DELETE_IMAGE = gql`
  mutation DeleteImage($input: DeleteImageInput!) {
    deleteImage(input: $input) {
      deleted
    }
  }
`
